export default "__VITE_ASSET__8kxuwnmz__"